import { render, staticRenderFns } from "./NavbarSubmenu.vue?vue&type=template&id=6f5c0420&scoped=true&"
import script from "./NavbarSubmenu.vue?vue&type=script&lang=js&"
export * from "./NavbarSubmenu.vue?vue&type=script&lang=js&"
import style0 from "./NavbarSubmenu.vue?vue&type=style&index=0&id=6f5c0420&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../store-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5c0420",
  null
  
)

export default component.exports